export enum RoleEnum {
  SUPERVISOR = "supervisor",
  ADMIN = "admin",
}
